export const GET_DEPARTMENTS = 'department/getDepartments';
export const GET_DEPARTMENT = 'department/getDepartment';
export const CREATE_DEPARTMENT = 'department/createDepartment';
export const UPDATE_DEPARTMENT = 'department/updateDepartment';
export const DELETE_DEPARTMENT = 'department/deleteDepartment';
